import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
// import NFTMarketplace from "views/admin/marketplace";
// import Profile from "views/admin/profile";
// import DataTables from "views/admin/tables";
// import RTLDefault from "views/rtl/default";
import Trainers from "views/admin/trainers";
import { MdCampaign,MdStar,MdSettings,MdNewReleases,MdGroup, MdHowToReg, MdContactPage, MdSend, MdCheckCircle, MdSchool, MdLocationOn, MdCollections, MdWork, MdReviews,MdMenu,MdCardGiftcard ,MdEventAvailable } from "react-icons/md";
import { FaInstagram,FaGift } from "react-icons/fa"
import Settings from "views/admin/Settings/Index";

// Icon Imports
import {
  MdHome,
  // MdBarChart,
  // MdPerson,
  MdOutlineDeveloperBoard,
  MdOutlineContactPage,
} from "react-icons/md";
import General from "views/admin/generalize/General";
import Courses from "views/admin/courses";
import Advertisement from "views/admin/advertisement/Index";
import NewBatch from "views/admin/NewBatch/components/NewBatch";
import Edit from "views/admin/courses/EditComponent/Edit";
import Modules from "views/admin/courses/ModuleComponent/Modules";
import HomePage from "views/admin/Settings/Components/HomePage";
import BeAtrainer from "views/admin/becomeAtrainer/component/BeAtrainer";
import HireFromUs from "views/admin/hireFromUs/component/HireFromUs";
import Contactus from "views/admin/contact us/components/Contactus";
import BrochureRequest from "views/admin/brochureRequest/component/BrochureRequest";
import BookCallback from "views/admin/bookCallback/component/BookCallback";
import Program from "views/admin/courses/ProgramComponent/Program";
import HiringPartners from "views/admin/Settings/Components/HiringPartners";
import CoursePage from "views/admin/Settings/Components/CoursePage";
import PlacementPage from "views/admin/Settings/Components/PlacementPage";
import Support from "views/admin/courses/SupportComponent/Support";
import CourseSection1 from "views/admin/courses/Section1Component/Section1";
import CourseSection2 from "views/admin/courses/Section2Component/Section2";
import AboutUs from "views/admin/Settings/Components/AboutUs";
import Placement from "views/admin/Placement/Placement";
import Location from "views/admin/Settings/Components/Location";
import Gallary from "views/admin/gallery/Gallary";
import TrainersPage from "views/admin/Settings/Components/TrainersPage";
import TesimonialPage from "views/admin/Settings/Components/TesimonialPage";
import UsefulLink from "views/admin/Settings/Components/UsefulLink";
import Jobpost from "views/admin/jobPost/Index";
import PlacementCount from "views/admin/Settings/Components/PlacementCount";
import Testimonials from "views/admin/Testimonial/copmponents/Testimonials";
import CourseTags from "views/admin/Settings/Components/CourseTags";
import Insta from "views/admin/instagramEdit/Insta";
import NavbarContent from "views/admin/Settings/Components/NavbarContent";
import Give from "views/admin/giveaway/Index";
import WalkinMain from "views/admin/walkin/Index";



const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Give Away",
    layout: "/admin",
    path: "give-away",
    icon: <MdCardGiftcard  className="h-6 w-6"/>,
    component: <Give />,
  },
  {
    name: "Walkin",
    layout: "/admin",
    path: "walkin",
    icon: <MdEventAvailable  className="h-6 w-6"/>,
    component: <WalkinMain />,
  },
  {
    name: "Generalizer",
    layout: "/admin",
    path: "general",
    icon: <MdStar className="h-6 w-6" />,
    component: <General />,
  },
  // {
  //   name: "Marketplace",
  //   layout: "/admin",
  //   path: "marketplace",
  //   icon: <MdOutlineDeveloperBoard className="h-6 w-6" />,
  //   component: <NFTMarketplace />,
  //   secondary: true,
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  // },
  {
    name: "New Batch Date",
    layout: "/admin",
    path: "new-batch",
    icon: <MdNewReleases className="h-6 w-6" />,
    component: <NewBatch />,
  },
  {
    name: "Courses",
    layout: "/admin",
    path: "Courses",
    icon: <MdOutlineDeveloperBoard className="h-6 w-6" />,
    component: <Courses />,
  },
  {
    name: "Trainers",
    layout: "/admin",
    icon: <MdOutlineContactPage className="h-6 w-6" />,
    path: "trainers",
    component: <Trainers />,
  },
  {
    name: "Advertisement",
    layout: "/admin",
    path: "advertisement",
    icon: <MdCampaign className="h-6 w-6" />,
    component: <Advertisement />,
  },
 
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // }, 
  {
    name: "Become a Trainer",
    layout: "/admin",
    path: "BeAtrainer",
    icon: <MdGroup className="h-6 w-6" />,
    component: <BeAtrainer />,
  },
  {
    name: "Hire From Us",
    layout: "/admin",
    path: "HireFromUs",
    icon: <MdHowToReg className="h-6 w-6" />,
    component: <HireFromUs />,
  },
  {
    name: "Testimonials",
    layout: "/admin",
    path: "testimonial",
    icon: <MdReviews className="h-6 w-6" />,
    component: <Testimonials />,
  },
  {
    name: "Contact Us",
    layout: "/admin",
    path: "contactus",
    icon: <MdContactPage className="h-6 w-6" />,
    component: <Contactus />,
  },
  {
    name: "Brochure Request",
    layout: "/admin",
    path: "brochureRequest",
    icon: <MdSend className="h-6 w-6" />,
    component: <BrochureRequest />,
  },
  {
    name: "Book Callback",
    layout: "/admin",
    path: "bookcallback",
    icon: <MdCheckCircle className="h-6 w-6" />,
    component: <BookCallback />,
  },
  {
    name: "Placement",
    layout: "/admin",
    path: "placementlist",
    icon: <MdSchool className="h-6 w-6" />,
    component: <Placement/>,
  },
  {
    name: "Job Post",
    layout: "/admin",
    path: "job-post",
    icon: <MdWork className="h-6 w-6" />,
    component: <Jobpost/>,
  },

  {
    name: "Gallery",
    layout: "/admin",
    path: "gallery",
    icon: <MdCollections className="h-6 w-6" />,
    component: <Gallary/>,
  },
  {
    name: "Instagram",
    layout: "/admin",
    path: "instagram",
    icon: < FaInstagram className="h-6 w-6" />,
    component: <Insta/>,
  },




  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
  {
    name: "EditCourses",
    layout: "/admin",
    path: "edit-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <Edit/>,
    noSidebar: true, 
  },
  {
    name: "Modules",
    layout: "/admin",
    path: "modules-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <Modules/>,
    noSidebar: true, 
  },
  {
    name: "Program",
    layout: "/admin",
    path: "program-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <Program/>,
    noSidebar: true, 
  },
  {
    name: "Support",
    layout: "/admin",
    path: "support-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <Support/>,
    noSidebar: true, 
  },
  {
    name: "Section1",
    layout: "/admin",
    path: "section1-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <CourseSection1/>,
    noSidebar: true, 
  },
  {
    name: "Section2",
    layout: "/admin",
    path: "section2-courses/:id",
    icon: <MdHome className="h-6 w-6" />,
    component: <CourseSection2/>,
    noSidebar: true, 
  },
  // {
  //   name: "JobDetails",
  //   layout: "/admin",
  //   path: "job-detail/:jobId",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <JobDetail/>,
  //   noSidebar: true, 
  // },
  // {
  //   name: "JobResponse",
  //   layout: "/admin",
  //   path: "job-response/:jobId",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <ResponseJob/>,
  //   noSidebar: true, 
  // },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Settings />,
    subRoutes: [
      { layout: "/admin", path: "homepage", name: "Home Page" , },
      { layout: "/admin", path: "placementpage", name: "Placement Page" },
      { layout: "/admin", path: "coursepage", name: "Courses Page" },
      { layout: "/admin", path: "hiringPartners", name: "Hiring Partners" },
      { layout: "/admin", path: "trainerpage", name: "Trainer Page" },
      { layout: "/admin", path: "testimonialpage", name: "Testimonial Page" },
      { layout: "/admin", path: "placementcount", name: "Placement Count" },
      { layout: "/admin", path: "aboutus", name: "About Us" },
      { layout: "/admin", path: "location", name: "Location" },
      { layout: "/admin", path: "useful-link", name: "Useful Link" },
      { layout: "/admin", path: "course-tags", name: "Course Tags" },
      { layout: "/admin", path: "navbar", name: "Navbar" },
    ],
  },
  {
    name: "Home",
    layout: "/admin",
    path: "homepage",
    icon: <MdHome className="h-6 w-6" />,
    component: <HomePage/>,
    noSidebar: true, 
  },
  {
    name: "Hiring Partners",
    layout: "/admin",
    path: "hiringpartners",
    icon: <MdHome className="h-6 w-6" />,
    component: <HiringPartners/>,
    noSidebar: true, 
  },
  {
    name: "Course Page",
    layout: "/admin",
    path: "coursepage",
    icon: <MdHome className="h-6 w-6" />,
    component: <CoursePage/>,
    noSidebar: true, 
  },
  {
    name: "Placement Page",
    layout: "/admin",
    path: "placementpage",
    icon: <MdHome className="h-6 w-6" />,
    component: <PlacementPage/>,
    noSidebar: true, 
  },

  {
    name: "Trainer Page",
    layout: "/admin",
    path: "trainerpage",
    icon: <MdHome className="h-6 w-6" />,
    component: <TrainersPage/>,
    noSidebar: true, 
  },

  {
    name: "Testimonial Page",
    layout: "/admin",
    path: "testimonialpage",
    icon: <MdHome className="h-6 w-6" />,
    component: <TesimonialPage/>,
    noSidebar: true, 
  },
  {
    name: "Placement Count",
    layout: "/admin",
    path: "placementcount",
    icon: <MdHome className="h-6 w-6" />,
    component: <PlacementCount/>,
    noSidebar: true, 
  },

  {
    name: "About Us",
    layout: "/admin",
    path: "aboutus",
    icon: <MdHome className="h-6 w-6" />,
    component: <AboutUs/>,
    noSidebar: true, 
  },
  {
    name: "Location",
    layout: "/admin",
    path: "location",
    icon: <MdLocationOn className="h-6 w-6" />,
    component: <Location/>,
    noSidebar: true, 
  },


  {
    name: "Useful Link",
    layout: "/admin",
    path: "useful-link",
    icon: <MdLocationOn className="h-6 w-6" />,
    component: <UsefulLink/>,
    noSidebar: true, 
  },
  {
    name: "Course Tags",
    layout: "/admin",
    path: "course-tags",
    icon: <MdHome className="h-6 w-6" />,
    component: <CourseTags/>,
    noSidebar: true, 
  },
  {
    name: "Navbar",
    layout: "/admin",
    path: "navbar",
    icon: <MdMenu className="h-6 w-6" />,
    component: <NavbarContent/>,
    noSidebar: true, 
  },


];
export default routes;
